<template>
    <section class="distributor-map-wrapper background-gradient-3">
        <div class="container wrap">
            <div class="row">
                <div class="col-xs-12">
                    <h1 class="distributor-map-wrapper__title">Distributors</h1>
                    <div class="distributor-list-wrapper">
                        <p class="distributor-list__title">National</p>
                        <div class="distributor-list">
                            <div
                                v-for="company in companies"
                                class="distributor-tile__logo"
                                @click="updateCompany(company)"
                            >
                                <img :src="company.Logo" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="container wrap">
        <section class="find-dealership" ref="find-dealership">
            <DistributorsSidebar />
            <DistributorsMap :input="input" />
        </section>
    </section>
</template>
<script>

    import DistributorsSidebar from './DistributorsSidebar.vue'
    import DistributorsMap from './DistributorsMap.vue'

    export default {
        components: {
            DistributorsSidebar,
            DistributorsMap,
        },
        data() {
            return {
                input: this.data.find(group => group.Title === 'Distributors').Distributors,
                companies: this.data.find(group => group.Title === 'National').Companies
            }
        },
        methods: {
            updateCompany(company) {
                window.scrollTo({
                    top: this.$refs['find-dealership'].offsetTop,
                    behavior: 'smooth'
                })
                this.$bus.emit('updateMap', {
                    group: 'National',
                    company
                })
            }
        }
    }

</script>
